import { render, staticRenderFns } from "./Cerere.vue?vue&type=template&id=7639bc5a&scoped=true&"
import script from "./Cerere.ts?vue&type=script&lang=ts&"
export * from "./Cerere.ts?vue&type=script&lang=ts&"
import style0 from "./Cerere.vue?vue&type=style&index=0&id=7639bc5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7639bc5a",
  null
  
)

export default component.exports
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QLinearProgress,QImg,QBtn,QIcon,QTooltip});
